import React from "react";

import IconButton from "../../../../../packages/IconButton";
import WPHeading from "../../../../../packages/WPHeading";

import { RemoveIcon } from "../../../../../assets/icons";

import "./LicenseFilterPills.scss";

const LicenseFilterPills = ({ icon, label, onRemove, dataTestId }) => (
  <div className="filter-pill" data-test-id={dataTestId}>
    {icon && <span className="filter-pill-icon">{icon}</span>}
    <WPHeading
      size="xSmall"
      tooltip={label}
      className="filter-pill-label"
      text={label}
      secondary
      wrapContent={true}
      id={`${dataTestId}-label`}
    />
    <IconButton
      className="filter-pill-close"
      onClick={onRemove}
      aria-label={`Remove ${label} filter`}
      id={`${dataTestId}-close`}
    >
      <RemoveIcon />
    </IconButton>
  </div>
);

export default LicenseFilterPills;
